import WindowVisibilityHelper from './AudioAlerts/WindowVisibilityHelper';
import { setInboxFaviconBadge } from './AudioAlerts/faviconHelper';

// Tab title and desktop notifications driven by the "My Inbox"
// (inbox-view) notification list, so a backgrounded tab shows what is waiting.

let baseTitle = null;

export const setInboxTabCount = count => {
  if (baseTitle === null) {
    baseTitle = document.title.replace(/^\(\d+\+?\)\s*/, '').trim();
  }
  const n = Number(count) || 0;
  const label = n > 99 ? '99+' : String(n);
  document.title = n > 0 ? `(${label}) ${baseTitle}` : baseTitle;
  setInboxFaviconBadge(n > 0);
};

const canNotify = () =>
  'Notification' in window && Notification.permission === 'granted';

// Same tag the server's web push uses (push_notification_service.rb), so a
// push landing for the same item replaces this one instead of stacking.
const pushTag = n => `${n.notification_type}_${n.primary_actor?.id}_${n.id}`;

export const showInboxDesktopNotification = ({
  notification,
  title,
  onClick,
}) => {
  if (!notification || !canNotify()) return;
  if (WindowVisibilityHelper.isWindowVisible()) return;

  const sender = notification.primary_actor?.meta?.sender?.name;
  const body = [sender, notification.push_message_body]
    .filter(Boolean)
    .join(': ');

  try {
    const desktop = new Notification(title, {
      body: body.slice(0, 240),
      tag: pushTag(notification),
      icon: '/android-icon-192x192.png',
      badge: '/favicon-96x96.png',
    });
    desktop.onclick = () => {
      window.focus();
      onClick?.();
      desktop.close();
    };
  } catch {
    // Some mobile browsers only allow notifications via the service worker.
  }
};
